import { takeLatest, put, call, fork, takeEvery } from 'redux-saga/effects';
import callApi from 'utils/api';
import * as actionTypes from './constants';
import {
  addAnnouncementFailure,
  addAnnouncementSuccess,
  deleteAnnouncementFailure,
  deleteAnnouncementSuccess,
  fetchAnnouncementsFailure,
  fetchAnnouncementsSuccess,
  fetchAnnouncementFailure,
  fetchWizardDataFailure,
  fetchWizardDataSuccess,
  updateAnnouncementFailure,
  updateAnnouncementSuccess,
  fetchAnnouncementSuccess,
  fetchAnnouncementsFeedSuccess,
  fetchAnnouncementsFeedFailure,
  fetchBannerAnnouncementSuccess,
  fetchBannerAnnouncementFailure,
  fetchBannerAnnouncement,
} from './announcements-actions';
import { announcementsToShowOnFeed } from '../../../utils/app-configs';

export function* doFetchWizardData(action) {
  try {
    const results = yield call(callApi, {
      endpoint: 'announcements/wizard',
      options: {
        errorMessage: 'Could not fetch wizard data',
        retryAction: action,
      },
    });
    yield put(fetchWizardDataSuccess(results));
  } catch (err) {
    yield put(fetchWizardDataFailure(err));
  }
}

export function* doFetchAnnouncements(action) {
  try {
    const results = yield call(callApi, {
      endpoint: 'announcements',
      options: {
        errorMessage: 'Could not fetch announcements',
        retryAction: action,
      },
    });
    yield put(fetchAnnouncementsSuccess(results));
  } catch (err) {
    yield put(fetchAnnouncementsFailure(err));
  }
}

export function* doFetchBannerAnnouncement(action) {
  try {
    const results = yield call(callApi, {
      endpoint: 'announcements/banner',
      options: {
        errorMessage: 'Could not fetch banner announcement',
        retryAction: action,
      },
    });
    yield put(fetchBannerAnnouncementSuccess(results));
  } catch (err) {
    yield put(fetchBannerAnnouncementFailure(err));
  }
}

export function* doUpdateAnnouncement(action) {
  const { id } = action.payload;
  try {
    const results = yield call(callApi, {
      endpoint: `announcements/${id}`,
      options: {
        method: 'PUT',
        body: JSON.stringify(action.payload),
        errorMessage: 'Could not update announcement data',
        retryAction: action,
      },
    });
    yield put(updateAnnouncementSuccess(results));
  } catch (err) {
    yield put(updateAnnouncementFailure(err));
  }
}

export function* doAddAnnouncement(action) {
  try {
    const results = yield call(callApi, {
      endpoint: 'announcements',
      options: {
        method: 'POST',
        body: JSON.stringify(action.payload),
        errorMessage: 'Could not add announcement data',
        retryAction: action,
      },
    });
    yield put(addAnnouncementSuccess(results));
  } catch (err) {
    yield put(addAnnouncementFailure(err));
  }
}

export function* doDeleteAnnouncement(action) {
  const { id } = action.payload;
  try {
    const results = yield call(callApi, {
      endpoint: `announcements/${id}`,
      options: {
        method: 'DELETE',
        errorMessage: 'Could not delete announcement',
        retryAction: action,
      },
    });
    yield put(fetchBannerAnnouncement());
    yield put(deleteAnnouncementSuccess(results));
  } catch (err) {
    yield put(deleteAnnouncementFailure(err));
  }
}

export function* doFetchAnnouncement(action) {
  try {
    const results = yield call(callApi, {
      endpoint: `announcements/${action.payload}`,
      options: {
        errorMessage: 'Could not fetch announcement data',
        retryAction: action,
      },
    });
    yield put(fetchAnnouncementSuccess(results));
  } catch (err) {
    yield put(fetchAnnouncementFailure(err));
  }
}

export function* doFetchFeedAnnouncements(action) {
  const { category, announcementId, isHome } = action.payload;
  try {
    const results = yield call(callApi, {
      // eslint-disable-next-line max-len
      endpoint: `announcements/feed?pageSize=${isHome ? announcementsToShowOnFeed : 100}${category ? `&category=${category}` : ''}${announcementId ? `&announcementId=${announcementId}` : ''}`,
      options: {
        errorMessage: 'Could not fetch announcements',
        retryAction: action,
      },
    });
    yield put(fetchAnnouncementsFeedSuccess({
      ...results,
      isHome,
    }));
  } catch (err) {
    yield put(fetchAnnouncementsFeedFailure({
      ...err,
      isHome,
    }));
  }
}

function* watchFetchAnnouncements() {
  yield takeLatest(actionTypes.FETCH_ANNOUNCEMENTS_REQUEST, doFetchAnnouncements);
}

function* watchFetchBannerAnnouncement() {
  yield takeLatest(actionTypes.FETCH_BANNER_ANNOUNCEMENT_REQUEST, doFetchBannerAnnouncement);
}

function* watchUpdateAnnouncement() {
  yield takeLatest(actionTypes.UPDATE_ANNOUNCEMENT_REQUEST, doUpdateAnnouncement);
}

function* watchFetchWizardData() {
  yield takeLatest(actionTypes.FETCH_ANNOUNCEMENT_WIZARD_DATA_REQUEST, doFetchWizardData);
}

function* watchAddAnnouncement() {
  yield takeLatest(actionTypes.ADD_ANNOUNCEMENT_REQUEST, doAddAnnouncement);
}

function* watchDeleteAnnouncement() {
  yield takeLatest(actionTypes.DELETE_ANNOUNCEMENT_REQUEST, doDeleteAnnouncement);
}

function* watchFetchAnnouncement() {
  yield takeLatest(actionTypes.FETCH_ANNOUNCEMENT_REQUEST, doFetchAnnouncement);
}

function* watchFetchFeedAnnouncements() {
  yield takeEvery(actionTypes.FETCH_ANNOUNCEMENTS_FEED_REQUEST, doFetchFeedAnnouncements);
}

export default [
  fork(watchFetchAnnouncements),
  fork(watchUpdateAnnouncement),
  fork(watchFetchWizardData),
  fork(watchAddAnnouncement),
  fork(watchDeleteAnnouncement),
  fork(watchFetchAnnouncement),
  fork(watchFetchFeedAnnouncements),
  fork(watchFetchBannerAnnouncement),
];
